import { render, staticRenderFns } from "./ShaclForm.vue?vue&type=template&id=64a431b2&scoped=true&"
import script from "./ShaclForm.vue?vue&type=script&lang=js&"
export * from "./ShaclForm.vue?vue&type=script&lang=js&"
import style0 from "./ShaclForm.vue?vue&type=style&index=0&id=64a431b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a431b2",
  null
  
)

component.options.__file = "ShaclForm.vue"
export default component.exports